export default __webpack_public_path__ + "static/media/general2024-2.7e892a1d.gif";